/**
 * 记录请求耗时的中间件
 */
import Constants from "@/constants";
import { TafMiddleware } from "../helper";

export const timeMiddleware: TafMiddleware = async (ctx, next) => {
  const enabled = Constants.IS_DEBUG || Constants.IS_USEDEBUG;
  const startTime = Date.now();
  if (enabled) {
    console.log(`[tafFetch] 开始请求: ${ctx.request.moduleName}.${ctx.request.funcName}`);
  }
  await next();
  const duration = Date.now() - startTime;
  ctx.response.duration = duration;
  if (enabled) {
    console.log(`[tafFetch] ${ctx.request.moduleName}.${ctx.request.funcName} 耗时: ${duration}ms`);
  }
};
